module.exports = __webpack_public_path__ + "static/img/red-envelope-top.7e78d11.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/alipay/red-envelope-top.png
// module id = n1YV
// module chunks = 1